'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import LocationHandler class */
import LocationHandler from '../../../shared/utility/location_handler/location_handler';

/** Import Cart class */
import Cart from '../../../shared/cart/cart';

/** Import AjaxHandler class */
import AjaxHandler from '../../../shared/utility/ajax_handler/ajax_handler';

/**
 * @class HomeHandler
 */
class HomeHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._searchButton = $('.frontoffice-tire-search-button');
        this._listenSearchFilters();
        this._listenAddToCart();
        this._listenFilterByCategory();
    }

    /**
     * @private
     */
    _listenFilterByCategory ()
    {
        $('#frontoffice-tire-categoryId').on('change', (e) =>
        {
            let value = $(e.target).val();
            if (!value)
            {
                value = 0;
            }

            let link = 'home/' + value + '/category';
            AjaxHandler.get(link).then((response) =>
            {
                if (response.manufacturers && response.manufacturers.length > 0)
                {
                    let manufacturersStr = '', manufacturerFilter = $('#frontoffice-tire-manufacturers');
                    $.each(response.manufacturers, (k, v) =>
                    {
                        manufacturersStr += '<option value="' + v.id + '">' + v.name + '</option>';
                    });
                    let manVal = manufacturerFilter.val();
                    manufacturerFilter.empty();
                    manufacturerFilter.html(manufacturersStr);
                    manufacturerFilter.val(manVal);
                    manufacturerFilter.trigger("chosen:updated");
                }

                if (response.widths)
                {
                    let widthStr = '', widthFilter = $('#frontoffice-tire-widths');
                    $.each(response.widths, (k, v) =>
                    {
                        widthStr += '<option value="' + v.id + '">' + v.name + '</option>';
                    });
                    let widthVal = widthFilter.val();
                    widthFilter.empty();
                    widthFilter.html(widthStr);
                    widthFilter.val(widthVal);
                    widthFilter.trigger("chosen:updated");
                }

                if (response.heights)
                {
                    let heightStr = '', heightFilter = $('#frontoffice-tire-heights');
                    $.each(response.heights, (k, v) =>
                    {
                        heightStr += '<option value="' + v.id + '">' + v.name + '</option>';
                    });
                    let heightVal = heightFilter.val();
                    heightFilter.empty();
                    heightFilter.html(heightStr);
                    heightFilter.val(heightVal);
                    heightFilter.trigger("chosen:updated");
                }

                if (response.diameters)
                {
                    let diameterStr = '', diameterFilter = $('#frontoffice-tire-diameters');
                    $.each(response.diameters, (k, v) =>
                    {
                        diameterStr += '<option value="' + v.id + '">' + v.name + '</option>';
                    });
                    let diameterVal = diameterFilter.val();
                    diameterFilter.empty();
                    diameterFilter.html(diameterStr);
                    diameterFilter.val(diameterVal);
                    diameterFilter.trigger("chosen:updated");
                }
            })
        })
    }

    /**
     * @private
     */
    _listenAddToCart ()
    {
        $('.add_to_cart').on('click', (e) =>
        {
            e.preventDefault();
            Cart.addToCart($(e.target).data('cartitem'));
        })
    }

    /**
     * @private
     */
    _listenSearchFilters ()
    {
        let that = this;
        that._searchButton.on('click', () =>
        {
            let
                selectors = that.constructor._filterSelectors(),
                filterObj = that.constructor._getEmptyFiltersObj();

            $.each(selectors, (k, v) =>
            {
                let val = $(v).val();

                if (v.indexOf('categoryId') >= 0)
                {
                    $.each($(v).find('option'), (a, b) =>
                    {
                        if (val === $(b).val() && $(b)[0].innerText !== 'Kategorija')
                        {
                            filterObj.kategorija.push($(b)[0].innerText.replace('/', '$'));
                        }
                    });
                }

                if (v.indexOf('seasonId') >= 0)
                {
                    $.each($(v).find('option'), (c, d) =>
                    {
                        if (val === $(d).val() && $(d)[0].innerText !== 'Sezona')
                        {
                            filterObj.sezona.push($(d)[0].innerText.split(' ')[0]);
                        }
                    });
                }

                if (v.indexOf('manufacturers') >= 0)
                {
                    let manufacturers = [];
                    $.each($(v).find('option'), (e, f) =>
                    {
                        if (val.indexOf($(f).val()) >= 0)
                        {
                            manufacturers.push($(f)[0].innerText);
                        }
                    });
                    filterObj.proizvođač = manufacturers;
                }

                if (v.indexOf('widths') >= 0)
                {
                    filterObj.širina = val;
                }

                if (v.indexOf('heights') >= 0)
                {
                    filterObj.visina = val;
                }

                if (v.indexOf('diameters') >= 0)
                {
                    filterObj.prečnik = val;
                }
            });
            that._generateLinkFromFilters(filterObj);
        });
    }

    /**
     * @param filterCollection
     */
    _generateLinkFromFilters (filterCollection)
    {
        let data = 'tires/search';
        $.each(filterCollection, (k, v) =>
        {
            if (v.length > 0)
            {
                data += '/';
                $.each(v, (a, b) =>
                {
                    data += k + '-' + b + '+';
                });
                data = data.slice(0, -1);
            }
        });
        LocationHandler.redirect(data);
    }

    /**
     * @returns {string[]}
     * @private
     */
    static _filterSelectors ()
    {
        return [
            '#frontoffice-tire-categoryId',
            '#frontoffice-tire-seasonId',
            '#frontoffice-tire-manufacturers',
            '#frontoffice-tire-widths',
            '#frontoffice-tire-heights',
            '#frontoffice-tire-diameters'
        ]
    }

    /**
     * @return {{kategorija: Array, sezona: Array, proizvođač: Array, širina: Array, visina: Array, prečnik: Array}}
     * @private
     */
    static _getEmptyFiltersObj ()
    {
        return {
            kategorija: [],
            sezona: [],
            proizvođač: [],
            širina: [],
            visina: [],
            prečnik: []
        }
    }
}

/** Start HomeHandler */
$(document).ready(() => { new HomeHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/home.js